/**
 * If you are not familiar with React Navigation, refer to the "Fundamentals" guide:
 * https://reactnavigation.org/docs/getting-started
 *
 */
// import { Ionicons } from "@expo/vector-icons/Ionicons";
import IconSafety from "react-native-vector-icons/AntDesign";
import Icon from "react-native-vector-icons/FontAwesome";
import IconMenu from "react-native-vector-icons/Entypo";
import {
  Image,
  Text,
  View,
  StyleSheet,
  TouchableOpacity,
  TextInput,
  Modal,
  Button,
  Switch,
  Alert,
  Dimensions,
  FlatList,
} from "react-native";
import { createBottomTabNavigator } from "@react-navigation/bottom-tabs";
import moment from "moment";
import { Dropdown } from "react-native-element-dropdown";

import {
  NavigationContainer,
  DefaultTheme,
  DarkTheme,
  CommonActions,
} from "@react-navigation/native";
import { createNativeStackNavigator } from "@react-navigation/native-stack";
import React, { useState, useRef, useEffect } from "react";
import { ColorSchemeName, Pressable } from "react-native";

import Colors from "../constants/Colors";
import useColorScheme from "../hooks/useColorScheme"; // @ts-ignore
import HomeScreen from "../screens/Home/HomeScreen";
import DeviceProfile from "../screens/Profile/DeviceProfile/DeviceProfile";

import LoginScreen from "../screens/Login/LoginScreen"; // @ts-ignore
import ModalScreen from "../screens/ModalScreen";
import NotFoundScreen from "../screens/NotFoundScreen";
import ResetPass from "../screens/ResetPassword/ResetPass"; // @ts-ignore
import Sidebar from "./sidebar";
import SidebarNew from "./sidebarNew";
import SidebarDrawer from "./SidebarDrawer";
import IconRefresh from "react-native-vector-icons/FontAwesome";

import { RootStackParamList } from "../types";
import LinkingConfiguration from "./LinkingConfiguration";
import SubZoneGroup from "../screens/Profile/SubzoneProfile/SubzoneProfile";
import ZoneGroup from "../screens/Profile/ZoneGroup";
import ProjectProfile from "../screens/Profile/ProjectProfile/ProjectProfile";
import FarmerProfile from "../screens/Profile/FarmerProfile/FarmerProfile";
import CreateFarmerProfile from "../screens/Profile/FarmerProfile/CreateFarmerProfile";

import EditFarmerProfile from "../screens/Profile/FarmerProfile/EditFarmerProfile";

import Country from "../screens/Masters/CountryMaster/Country";
import City from "../screens/Masters/CityMaster/City";
import Tahasil from "../screens/Masters/TahasilMaster/Tahasil";
import States from "../screens/Masters/StateMaster/States";
import DocumentType from "../screens/Masters/DocumentTypeMaster/DocumentType";
import UserType from "../screens/Masters/UserTypeMaster/UserType";
import ProjectType from "../screens/Masters/ProjectTypeMaster/ProjectType";
import UserMasters from "../screens/Masters/UserMaster/UserMasters";
import AccessMaster from "../screens/AccessMaster/UserAccess";
import { createPortal } from "react-dom";

import Village from "../screens/Masters/VillageMaster/Village";
import AsyncStorage from "@react-native-async-storage/async-storage";
import CreateDevice from "../screens/Profile/DeviceProfile/CreateDeviceProfile";
import CreateUserMaster from "../screens/Masters/UserMaster/CreateUserMaster";
import { postData, baseUrlimage, baseUrl } from "../networking/api";
import IconEdit from "react-native-vector-icons/FontAwesome";
import IconLogout from "react-native-vector-icons/AntDesign";
import EditUserMaster from "../screens/Masters/UserMaster/EdiUserMaster";
import AlertScreen from "../screens/Alerts/AlertScreen";
import ProjectLevel from "../screens/Masters/ProjectLevel/ProjectLevel";
import ProjectLevelView from "../screens/Masters/ProjectLevel/ProjectLevelView";
import EditProjectProfile from "../screens/Profile/ProjectProfile/EditProjectprofile";
import CreateProjectProfile from "../screens/Profile/ProjectProfile/CreateProjectProfile";
import SubzoneProfile from "../screens/Profile/SubzoneProfile/SubzoneProfile";
import EditSubzoneProfile from "../screens/Profile/SubzoneProfile/EditSubZoneProfile";
import CreateSubzoneProfile from "../screens/Profile/SubzoneProfile/CreateSubzoneProfile";
import ZoneProfile from "../screens/Profile/ZoneProfile/ZoneProfile";
import CreateZoneProfile from "../screens/Profile/ZoneProfile/CreateZoneProfile";
import EditZoneProfile from "../screens/Profile/ZoneProfile/EditZoneProfile";
import CreateDeviceProfile from "../screens/Profile/DeviceProfile/CreateDeviceProfile";
import EditDeviceProfile from "../screens/Profile/DeviceProfile/EditDeviceProfile";
import ScheduleProgram from "../screens/ScheduleProgram/ScheduleProgram";
import ViewSubzoneProfile from "../screens/Profile/SubzoneProfile/ViewSubzoneProfile";
import ViewZoneProfile from "../screens/Profile/ZoneProfile/ViewZoneProfile";
import ViewProjectProfile from "../screens/Profile/ProjectProfile/ViewProjectprofile";
import UserAccess from "../screens/AccessMaster/UserAccess";
import ProjectAccess from "../screens/AccessMaster/ProjectAccess";
import SchedularMapView from "../screens/ScheduleProgram/SchedularMapView";
import GridView from "../screens/Monitors/GridView";
import MapView from "../screens/Monitors/MapView";
import UploadSchedule from "../screens/ScheduleProgram/UploadSchedule";
import DownloadSchedule from "../screens/ScheduleProgram/DownloadSchedule";
import OmegaDevice from "../screens/Masters/OmegaDevice/OmegaDevice";
import Program from "../screens/Reports/Program";
import ValveAccumulation from "../screens/Reports/ValveAccumulation";
import WaterAccumulation from "../screens/Reports/WaterAccumulation";
import Sensor from "../screens/Reports/Sensor";
import EnergyLog from "../screens/Reports/EnergyLog";
import { useSelector, useDispatch } from "react-redux";
import {
  projectIdUpdate,
  projectCodes,
  projectName,
  projectIdCreate,
} from "../components/redux/actions";
import { ActivityIndicator } from "react-native-paper";
import Zone from "../screens/Monitors/Zone";
import Subzone from "../screens/Monitors/Subzone";
import ValveView from "../screens/Monitors/ValveView";
import ValveDetailsReport from "../screens/Home/ValveDetailsReport";
import SensorDetailsReport from "../screens/Home/SensorDetailsReport";
import DeviceDetailsReport from "../screens/Home/DeviceDetailsReport";
import { ScrollView } from "react-native-gesture-handler";
import EditFarmerDetails from "../screens/FarmerDetails/EditFarmerDetails";
import Feedback from "../screens/Feedback/Feedback";
import DigitalDetailsReport from "../screens/Home/DigitalDetailsReport";
import DigitalInputsReport from "../screens/Home/DigitalInputsReport";
import EnergyStatusDetailReport from "../screens/Home/EnergyStatusDetailReport";
import SuccessPopup from "../components/SuccessPopup";
import DashboardAccess from "../screens/AccessMaster/DashboardAccess";

const userIcon = require("../assets/images/usericon.png");
const projectIcon = require("../assets/images/pricon.png");
export default function Header({
  colorScheme,
  navigation,
}: {
  colorScheme: ColorSchemeName;
}) {
  const [isVisible, setIsVisible] = useState(false);
  const [issuccessVisible, setissuccessVisible] = useState(false);
  const [responsestatus, setresponsestatus] = useState("");
  const [PopupMessage, setPopupMessage] = useState("");
  const [error, setError] = useState("");
  const [username, setUsername] = useState("");
  const [farmerName, setFarmerName] = useState("");

  const [userId, setUserId] = useState("");
  const [projectId, setprojectId] = useState("");

  const [profileImage, setProfileImage] = useState("");
  const [projectProfile, setProjectProfile] = useState(null);

  const [projectTitle, setProjectTitle] = useState("");
  const [projectManager, setProjectManager] = useState("");
  const [clientName, setClientName] = useState("");

  const [projectSelected, setProjectSelected] = useState("");
  var dispatch = useDispatch();
  const [isAdd, setisAdd] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingProject, setIsLoadingProject] = useState(false);

  var alpha_pattern = new RegExp(/^[a-zA-Z]+(\s[a-zA-Z]+)?$/);

  const [ProjectTypeNameData, setProjectTypeNameData] = useState([]);
  const [ProjectsData, setProjectData] = useState([]);
  const [projectTypeValue, setProjectTypeValue] = useState("");
  const [projectTypeValId, setProjectTypeValueId] = useState("");

  const [projectValue, setProjectValue] = useState("");
  const [projectValId, setProjectValueId] = useState("");
  const [isLoadingSync, setIsLoadingSync] = useState(false);

  const [userTypeValue, setUserTypeValue] = useState("");

  const [isLoginToken, setLoginToken] = useState(null);
  const [OmegaDropdownData, setOmegaDropdownData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [searchData, setSearchData] = useState<any>([]);
  const [OmegaValue, setOmegaValue] = useState<any>({});
  const inputRef = useRef<any>(null);

  useEffect(() => {
    getAdminData();
    // getProjectTypeList();
  }, []);
  // useEffect(() => {
  //   if (isLoginToken === null) {
  //     navigation.navigate('Login')
  //   }
  // }, [isLoginToken]);
  const buttonPressed = useSelector((state) => state.isUpdating);
  // const createProjId = useSelector((state) => state.idCreating)

  useEffect(() => {
    getAdminData();
  }, [buttonPressed]);

  const getAdminData = async () => {
    let jsonValue = await AsyncStorage.getItem("userData");

    let userTokenData = await AsyncStorage.getItem("userToken");
    let projValue = await AsyncStorage.getItem("projectData");
    // let projectIDS = await AsyncStorage.getItem("projectids");
    let userTypes = await AsyncStorage.getItem("userTypes");
    var userDetailsresponse = JSON.parse(jsonValue);

    setUserId(userDetailsresponse.id);
    getProjectTypeList(userDetailsresponse.id);
    if (projValue != null) {
      setUserTypeValue(userTypes);
      setprojectId(projValue);
      getProjectProfileById(projValue);
      getOmegaDependentDropdownByProjectId(projValue);

      // getProjectProfileById(userTypes == "1" ? projValue : projectIDS);
    } else if (jsonValue != null) {
      var userDetailsresponse = JSON.parse(jsonValue);
      getProjectTypeList(userDetailsresponse.id);
      setprojectId(userDetailsresponse.project_selected);
      setUserTypeValue(userTypes);
      // getProjectProfileById(
      //   userTypes == "1"
      //     ? userDetailsresponse.project_selected
      //     : userDetailsresponse.project_id
      // );
      getProjectProfileById(userDetailsresponse.project_selected);
      getOmegaDependentDropdownByProjectId(
        userDetailsresponse.project_selected
      );
    }

    if (userTokenData === null) {
      navigation.navigate("Login");
    } else {
      if (jsonValue != null) {
        var userDetailsresponse = JSON.parse(jsonValue);
        // setFarmerName(userDetailsresponse.farmer_name);
        setUsername(
          userDetailsresponse.first_name.charAt(0).toUpperCase() +
            userDetailsresponse.first_name.slice(1) +
            " " +
            userDetailsresponse.last_name.charAt(0).toUpperCase() +
            userDetailsresponse.last_name.slice(1)
        );
        setProfileImage(
          baseUrlimage +
            "uploads/profile_picture/" +
            userDetailsresponse.profile_pic
        );

        setUserId(userDetailsresponse.id);
        setprojectId(userDetailsresponse.project_selected);

        // setLoginToken(userTokenData);

        // if (userDetailsresponse.token === null) {
        //   navigation.navigate('Login')
        // }
        // setProjectTitle("Project 1");
        // setProjectManager("Mr.Basu");

        // getProjectProfileById(userDetailsresponse.project_selected);
        setProjectSelected(userDetailsresponse.project_selected);
        if (userDetailsresponse.project_selected === null) {
          setIsVisible(true);
          setisAdd(true);
        } else {
          setIsVisible(false);
          setisAdd(false);
          // setProjectSelected(projectValId);
        }
      }
    }
  };
  // dashboard data when click on refresh button
  const getDashboardRefresh = async () => {
    setIsLoadingSync(true);
    let projValue = await AsyncStorage.getItem("projectData");
    let jsonValue = await AsyncStorage.getItem("userData");
    var userDetailsresponse = JSON.parse(jsonValue);
    try {
      var dashSyncData = JSON.stringify({
        project_id:
          projValue !== null ? projValue : userDetailsresponse.project_selected,
      });
      const dashSyncResponse = await postData(
        dashSyncData,
        "masters/liveMonitoring"
      );
      setIsLoadingSync(false);
      var code = dashSyncResponse.code;
      if (code == 1) {
        // //alert(dashSyncResponse.message);
        setPopupMessage("Data synchronization Successfully");
        setissuccessVisible(true);
        setresponsestatus("success");
        setIsVisible(false);
      } else {
        setIsLoadingSync(false);
        setissuccessVisible(true);
        setresponsestatus("failed");
        setPopupMessage(dashSyncResponse.message);
        // //alert(dashSyncResponse.message);
      }
    } catch (error) {
      setIsLoadingSync(false);
      // console.log(error);
    }
  };

  //Get project profile  data by id
  const getProjectProfileById = async (id) => {
    setIsLoading(true);
    try {
      var ProfileData = JSON.stringify({
        module: "project",
        relation: [
          {
            module: "project_type",
          },
          {
            module: "project_devices",
            subModule: "devices_master",
          },
        ],
        id: id,
      });

      const ProjectProfileDataById = await postData(
        ProfileData,
        "/masters/getMasterList"
      );
      setIsLoading(false);
      var code = ProjectProfileDataById.code;
      if (code == 1) {
        var profileUrl =
          baseUrlimage +
          "uploads/project_profile/" +
          ProjectProfileDataById.data[0].profile_pic;
        setProjectProfile(profileUrl);
        setProjectTitle(ProjectProfileDataById.data[0].project_name);
        setProjectManager(ProjectProfileDataById.data[0].contractor);
        setClientName(ProjectProfileDataById.data[0].client);
        dispatch(projectCodes());
        dispatch(projectName());
        AsyncStorage.setItem(
          "projectCode",
          JSON.stringify(ProjectProfileDataById.data[0].project_code)
        );
        AsyncStorage.setItem(
          "projectName",
          JSON.stringify(ProjectProfileDataById.data[0].project_name)
        );
        AsyncStorage.setItem(
          "projectAllData",
          JSON.stringify(ProjectProfileDataById.data[0])
        );
      } else {
        setIsLoading(false);
        // //alert(ProjectProfileDataById.message);
      }
    } catch (error) {
      setIsLoading(false);
      // console.log(error);
    }
  };

  const isCreatable = () => {
    setIsVisible(true);
    setisAdd(true);
  };
  // const isAddable = (projectTypeId, projectTypename, project_name) => {
  //   setIsVisible(true);
  //   setisAdd(false);

  //   //Set name to update
  //   // setProjectTypeValue(projectTypename);
  //   setProjectValue(project_name);

  //   //set id to update
  //   setProjectTypeValueId(projectTypename);
  //   setProjectValueId(project_name);
  // };

  const isAddable = () => {
    setIsVisible(true);
    setisAdd(false);
  };

  // project type Get Api
  // const getProjectTypeList = async () => {
  //   setIsLoadingProject(true);
  //   try {
  //     var ProjectTypeData = JSON.stringify({
  //       module: "project_type",
  //       relation: [],
  //     });
  //     const ProjectTypeList = await postData(
  //       ProjectTypeData,
  //       "masters/getMasterList"
  //     );
  //     setIsLoadingProject(false);
  //     var code = ProjectTypeList.code;
  //     if (code == 1) {
  //       setProjectTypeNameData(ProjectTypeList.data);
  //     } else {
  //       setIsLoadingProject(false);
  //       // //alert(ProjectTypeList.message);
  //     }
  //   } catch (error) {
  //     setIsLoadingProject(false);
  //     // console.log(error);
  //   }
  // };

  const getProjectTypeList = async (userid) => {
    //GET request

    const payload = JSON.stringify({
      module: "project_type",
    });

    const projectTypeResponse = await postData(
      payload,
      "masters/getMasterList"
    );
    setProjectTypeNameData(projectTypeResponse.data);
    return false;
    fetch(baseUrl + "masters/userwiseProjectType/" + userid, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        // Authorization: "",
      },
      //Request Type
    })
      .then((response) => response.json())
      //If response is in json then in success
      .then((responseJson) => {
        //Success
        // //alert(JSON.stringify(responseJson));

        setProjectTypeNameData(responseJson.data);
      })
      //If response is not in json then in error
      .catch((error) => {
        //Error
        // //alert(JSON.stringify(error));
        console.error("valve error", error);
      });
  };
  //userwiseProjectType

  // Get dependent project by project type
  const getDependentProjectTypeMaster = async (project_type_id) => {
    setIsLoading(true);

    try {
      var dependentData = JSON.stringify({
        user_id: userId,
        project_type_id: project_type_id,
        // data: {
        //   column: "project_type",
        //   value: project_type_id,
        // },
      });
      const dependentProjectTypeDataResponse = await postData(
        dependentData,
        "masters/getProjectDataByUserId"
      );
      setIsLoading(false);
      var code = dependentProjectTypeDataResponse.code;
      if (code == 1) {
        // setCountryLength(dependentProjectTypeDataResponse.data.length);
        setProjectData(dependentProjectTypeDataResponse.data);
      } else {
        setIsLoading(false);
        // //alert(dependentProjectTypeDataResponse.message);
      }
    } catch (error) {
      setIsLoading(false);
      // console.log(error);
    }
  };
  const renderProjectTypeItem = (item: any) => {
    return (
      <View style={styles.item}>
        <Text style={styles.textItem}>{item.type}</Text>
        {item.id === projectTypeValId && (
          <IconSafety
            style={styles.icon}
            color="black"
            name="Safety"
            size={20}
          />
        )}
      </View>
    );
  };

  const renderProjectItem = (item: any) => {
    return (
      <View style={styles.item}>
        <Text style={styles.textItem}>{item.project_name}</Text>
        {item.id === projectValId && (
          <IconSafety
            style={styles.icon}
            color="black"
            name="Safety"
            size={20}
          />
        )}
      </View>
    );
  };

  const CheckEnteredData = async () => {
    if (projectTypeValue == "" && projectValue == "") {
      setError("Please select project type");
      // setIsVisible(false);
    } else if (projectTypeValue && projectValue) {
      await AsyncStorage.removeItem("cachedDashboard");

      {
        isAdd == true && createProjectType();
        setIsLoading(true);
        setIsVisible(false);
      }

      {
        isAdd == false && updateProjectType();
        setIsVisible(false);
      }
    } else {
      // setError("Please enter Character Only.");
    }
  };
  const getOmegaDependentDropdownByProjectId = async (project_id: any) => {
    try {
      var OmegaIdData = JSON.stringify({
        column: "project_id",
        value: project_id,
        module: "devices_master",
      });
      const OmegaIdList = await postData(
        OmegaIdData,
        "masters/getDependentMasterList"
      );
      setIsLoading(false);
      var code = OmegaIdList.code;
      if (code == 1) {
        setSearchData(OmegaIdList.data);
      } else {
        setIsLoading(false);
      }
    } catch (error) {}
  };

  const search = (data: any[], query: string): any[] => {
    const lowerCaseQuery = query.toLowerCase();

    return data.filter((item) =>
      item?.device_name?.toLowerCase().includes(lowerCaseQuery)
    );
  };
  const handleSearch = async (query: string) => {
    setSearchQuery(query);
    if (query.trim()) {
      const searchResultData = search(searchData, query);
      setOmegaDropdownData(searchResultData);
    }
  };
  const OmegaDropdownPortal = ({
    data,
    inputRef,
    renderItem,
  }: {
    data: any[];
    inputRef: any;
    renderItem: any;
  }) => {
    if (!data?.length || !inputRef.current) return null;

    const rect = inputRef.current.getBoundingClientRect();

    return createPortal(
      <div
        style={{
          position: "absolute",
          top: rect.bottom + window.scrollY,
          left: rect.left + window.scrollX,
          width: rect.width,
          maxHeight: 300,
          overflowY: "auto",
          backgroundColor: "#fff",
          border: "1px solid #007bff",
          borderRadius: 6,
          zIndex: 99999,
          boxShadow: "0px 2px 6px rgba(0,0,0,0.25)",
        }}
      >
        <FlatList
          data={data}
          keyExtractor={(_, index) => index.toString()}
          renderItem={renderItem}
          scrollEnabled={false}
          contentContainerStyle={{
            backgroundColor: "#fff",
            flexGrow: 1,
          }}
        />
      </div>,
      document.body
    );
  };

  const renderOmegaIdListItems = ({
    item,
    index,
  }: {
    item: any;
    index: any;
  }) => {
    return (
      <TouchableOpacity
        activeOpacity={1}
        style={{
          zIndex: 99999,
          height: 50,
          justifyContent: "center",
          backgroundColor: "#fff",
          width: "100%",
          paddingLeft: 10,
        }}
        onPress={() => {
          window.open(
            `/ValveView?OmegaId=${item.omega_id}&OmegaName=${item.device_name}&basedOn=${item.based_on}`,
            "_blank"
          );
          setOmegaDropdownData([]);
          setSearchQuery("");
        }}
      >
        {isAdd == true && (
          <Text style={styles.textItem}>{item.device_name}</Text>
        )}
        {isAdd == false && (
          <Text style={styles.textItem}>{item.device_name}</Text>
        )}
        {item.id === OmegaValue?.id && (
          <IconSelect
            style={styles.icon}
            color="black"
            name="Safety"
            size={20}
          />
        )}
      </TouchableOpacity>
    );
  };
  //Project Type create API
  const createProjectType = async () => {
    setIsLoading(true);
    try {
      var projectTypeData = JSON.stringify({
        module: "user_master",
        id: userId,
        data: {
          project_selected: projectValId,
        },
      });

      const projectTypeResponse = await postData(
        projectTypeData,
        "masters/masterCreateUpdate"
      );

      setIsLoading(false);

      var code = projectTypeResponse.code;
      if (code == 1) {
        // //alert(projectTypeResponse.message);
        setIsVisible(false);
        // getProjectTypeList();
        setProjectTypeValue("");
        // dispatch(projectIdCreate())

        AsyncStorage.setItem("projectSelect", JSON.stringify(projectValId));
        setProjectSelected(projectValId);
      } else {
        setIsLoading(false);
        // //alert(projectTypeResponse.message);
      }
    } catch (error) {
      setIsLoading(false);
      // console.log(error);
    }
  };

  //project type Update API
  const updateProjectType = async () => {
    setIsLoading(true);
    try {
      var ProjectTypeData = JSON.stringify({
        module: "user_master",
        id: userId,
        data: {
          project_selected: projectValId,
        },
      });

      await AsyncStorage.setItem("projectData", JSON.stringify(projectValId));
      getProjectProfileById(projectValId);
      const ProjectTypeResponse = await postData(
        ProjectTypeData,
        "masters/masterCreateUpdate"
      );

      setIsLoading(false);

      var code = ProjectTypeResponse.code;
      if (code == 1) {
        // //alert(ProjectTypeResponse.message);
        // navigation.navigate("Home")
        window.location.href = "/dashboard";
        setIsVisible(false);
        getProjectTypeList(userId);

        dispatch(projectIdUpdate());

        // setProjectSelected(ProjectTypeResponse.data[0].id)
      } else {
        setIsLoading(false);
        // //alert(ProjectTypeResponse.message);
      }
    } catch (error) {
      setIsLoading(false);
      // console.log(error);
    }
  };
  function ProjectTypeModal() {
    return (
      <>
        <Modal
          onRequestClose={() => setIsVisible(false)}
          transparent
          visible={isVisible}
        >
          <View
            style={{
              position: "absolute",
              width: "100%",
              height: "100%",
              justifyContent: "center",
              alignItems: "center",
              alignContent: "center",
              backgroundColor: "rgba(100,100,100, 0.5)",
            }}
          >
            <View
              style={{
                backgroundColor: "white",
                borderColor: "#eee",
                borderRadius: 10,
                borderWidth: 1,
                height: "40%",
                margin: "auto",
                padding: 30,
                shadowOffset: {
                  width: 0,
                  height: 2,
                },
                shadowOpacity: 0.25,
                shadowRadius: 4,
                elevation: 5,

                width: "30%",
              }}
            >
              <View style={{ width: "100%" }}>
                <Text style={{ fontWeight: "500" }}>Project Type</Text>
                {isAdd == true && (
                  <View>
                    <Dropdown
                      style={styles.dropdown}
                      placeholderStyle={styles.placeholderStyle}
                      selectedTextStyle={styles.selectedTextStyle}
                      inputSearchStyle={styles.inputSearchStyle}
                      iconStyle={styles.iconStyle}
                      data={ProjectTypeNameData}
                      search
                      maxHeight={300}
                      labelField="type"
                      valueField="type"
                      placeholder="Select Project Type"
                      searchPlaceholder="Search..."
                      value={projectTypeValue}
                      onChange={(item) => {
                        setProjectTypeValue(item.type);
                        setProjectTypeValueId(item.id);
                        setProjectValue("");
                        getDependentProjectTypeMaster(item.id);
                      }}
                      renderItem={renderProjectTypeItem}
                    />
                    <Text
                      style={{
                        color: "red",
                        fontSize: 14,
                        fontWeight: "600",
                        width: "70%",
                        marginLeft: 0,
                      }}
                    >
                      {error}
                    </Text>
                  </View>
                )}
                {isAdd == false && (
                  <View>
                    <Dropdown
                      style={styles.dropdown}
                      placeholderStyle={styles.placeholderStyle}
                      selectedTextStyle={styles.selectedTextStyle}
                      inputSearchStyle={styles.inputSearchStyle}
                      iconStyle={styles.iconStyle}
                      data={ProjectTypeNameData}
                      search
                      maxHeight={300}
                      labelField="type"
                      valueField="type"
                      placeholder="Select Project Type"
                      searchPlaceholder="Search..."
                      value={projectTypeValue}
                      onChange={(item) => {
                        setProjectTypeValue(item.type);
                        setProjectTypeValueId(item.id);
                        setProjectValue("");
                        getDependentProjectTypeMaster(item.id);
                      }}
                      renderItem={renderProjectTypeItem}
                    />
                    <Text
                      style={{
                        color: "red",
                        fontSize: 14,
                        fontWeight: "600",
                        width: "70%",
                        marginLeft: 0,
                      }}
                    >
                      {error}
                    </Text>
                  </View>
                )}
              </View>
              <View style={{ width: "100%" }}>
                <Text style={{ fontWeight: "500" }}>Project</Text>
                {isAdd == true && (
                  <View>
                    <Dropdown
                      style={styles.dropdown}
                      placeholderStyle={styles.placeholderStyle}
                      selectedTextStyle={styles.selectedTextStyle}
                      inputSearchStyle={styles.inputSearchStyle}
                      iconStyle={styles.iconStyle}
                      data={ProjectsData}
                      search
                      maxHeight={300}
                      labelField="project_name"
                      valueField="project_name"
                      placeholder="Select Project"
                      searchPlaceholder="Search..."
                      value={projectValue}
                      onChange={(item) => {
                        setProjectValue(item.project_name);
                        setProjectValueId(item.id);
                      }}
                      renderItem={renderProjectItem}
                    />
                    <Text
                      style={{
                        color: "red",
                        fontSize: 14,
                        fontWeight: "600",
                        width: "70%",
                        marginLeft: 0,
                      }}
                    >
                      {error}
                    </Text>
                  </View>
                )}

                {isAdd == false && (
                  <View>
                    <Dropdown
                      style={styles.dropdown}
                      placeholderStyle={styles.placeholderStyle}
                      selectedTextStyle={styles.selectedTextStyle}
                      inputSearchStyle={styles.inputSearchStyle}
                      iconStyle={styles.iconStyle}
                      data={ProjectsData}
                      search
                      maxHeight={300}
                      labelField="project_name"
                      valueField="project_name"
                      placeholder="Select Project"
                      searchPlaceholder="Search..."
                      value={projectValue}
                      onChange={(item) => {
                        setProjectValue(item.project_name);
                        setProjectValueId(item.id);
                      }}
                      renderItem={renderProjectItem}
                    />
                    <Text
                      style={{
                        color: "red",
                        fontSize: 14,
                        fontWeight: "600",
                        width: "70%",
                        marginLeft: 0,
                      }}
                    >
                      {error}
                    </Text>
                  </View>
                )}
              </View>
              {isAdd == true && (
                <View
                  style={{
                    flexDirection: "row",
                    justifyContent: "space-evenly",
                    marginHorizontal: 20,
                    marginTop: 20,
                  }}
                >
                  <TouchableOpacity
                    style={{
                      alignItems: "center",
                      backgroundColor: "#006EB9",
                      padding: 10,
                      borderWidth: 1,
                      borderColor: "#006EB9",
                      width: "50%",
                      marginRight: 10,
                    }}
                    onPress={() => CheckEnteredData()}
                  >
                    <Text style={{ color: "#fff", fontWeight: "600" }}>
                      Save
                    </Text>
                  </TouchableOpacity>

                  <TouchableOpacity
                    style={{
                      alignItems: "center",
                      backgroundColor: "#006EB9",
                      padding: 10,
                      borderWidth: 1,
                      borderColor: "#006EB9",
                      width: "50%",
                      marginRight: 10,
                    }}
                    onPress={() => setIsVisible(false)}
                  >
                    <Text style={{ color: "#fff", fontWeight: "600" }}>
                      Cancel
                    </Text>
                  </TouchableOpacity>
                </View>
              )}
              {isAdd == false && (
                <View
                  style={{
                    flexDirection: "row",
                    justifyContent: "space-evenly",
                    marginHorizontal: 20,
                    marginTop: 20,
                  }}
                >
                  <TouchableOpacity
                    style={{
                      alignItems: "center",
                      backgroundColor: "#006EB9",
                      padding: 10,
                      borderWidth: 1,
                      borderColor: "#006EB9",
                      width: "50%",
                      marginRight: 10,
                    }}
                    onPress={() => CheckEnteredData()}
                  >
                    <Text style={{ color: "#fff", fontWeight: "600" }}>
                      Update
                    </Text>
                  </TouchableOpacity>

                  <TouchableOpacity
                    style={{
                      alignItems: "center",
                      backgroundColor: "#006EB9",
                      padding: 10,
                      borderWidth: 1,
                      borderColor: "#006EB9",
                      width: "50%",
                      marginRight: 10,
                    }}
                    onPress={() => setIsVisible(false)}
                  >
                    <Text style={{ color: "#fff", fontWeight: "600" }}>
                      Cancel
                    </Text>
                  </TouchableOpacity>
                </View>
              )}

              {/* <Gap />
          {isVisible ? <Modalception depth={depth + 1} /> : null}
          <Gap /> */}
            </View>
          </View>
        </Modal>
      </>
    );
  }
  const logout = () => {
    AsyncStorage.clear();
    navigation.dispatch(
      CommonActions.reset({
        index: 1,
        routes: [{ name: "Login" }],
      })
    );
  };
  const screenwidth = Dimensions.get("window").width;
  const isMobile = screenwidth < 768;

  return (
    <View
      style={{ flexDirection: "row", backgroundColor: "#fff", height: "100%" }}
    >
      <View>{userTypeValue == "1" && <SidebarDrawer />}</View>

      {/* {isLoading} */}
      {/* Sidebar  */}
      {/* <Sidebar /> */}
      {/* <SidebarNew /> */}
      {/* {userTypeValue == "1" && <SidebarDrawer />} */}
      {/* Header  */}
      <View
        style={{
          flex: 1,
          // borderWidth:6,
          // display: 'flex',
          // flexDirection: 'column'
        }}
      >
        <View
          style={{
            flex: 1,
            height: "50%",
            backgroundColor: "#fff",
            position: "absolute",
            top: 0,
          }}
        >
          <View
            style={{
              flexDirection: "row",
              flex: 1,
              justifyContent: "flex-end",
            }}
          >
            <Text style={{ margin: 5, color: "#7E7E7E" }}>
              <Icon name="calendar" size={20} color="#7E7E7E" />{" "}
              {moment().format("Do MMM YYYY")}
            </Text>
            <Text style={{ margin: 5, color: "#7E7E7E" }}>
              <Icon name="clock-o" size={20} color="#7E7E7E" />{" "}
              {moment().format("LT")}
            </Text>
          </View>
        </View>
        {/* start of Header title */}
        {projectSelected == null ? (
          <View
            style={{
              // flex: 2,
              flexDirection: "row",
              alignItems: "center",
              backgroundColor: "#009DF0",
              justifyContent: "flex-start",
              // marginBottom: "30%",
            }}
          >
            {/* End of project title */}

            {/* Username  */}
            <View
              style={{
                justifyContent: "flex-end",
                flexDirection: "row",
              }}
            >
              <View
                style={{
                  flex: 1,
                }}
              >
                <Image
                  source={
                    profileImage
                      ? { uri: profileImage }
                      : require("../assets/images/projectImg.png")
                  }
                  style={{ width: 28, height: 38, margin: 6 }}
                />
              </View>
              <View>
                <Text style={{ margin: 15, color: "#fff" }}>{username} </Text>
              </View>
            </View>
            {/* username end */}
          </View>
        ) : isLoadingProject ? (
          <ActivityIndicator
            //visibility of Overlay Loading Spinner
            color="#1DA1F2"
            visible={isLoadingProject}
            //Text with the Spinner
            textContent={"Loading..."}
            size={40}
            //  //Text style of the Spinner Text
            //  textStyle={styles.spinnerTextStyle}
          />
        ) : (
          <View
            style={isMobile ? styles.mobileContainer : styles.topBarContainer}
          >
            <View
              style={{
                width: "70%",
                flexDirection: "row",
                justifyContent: "flex-start",
              }}
            >
              <View
                style={
                  isMobile
                    ? { marginLeft: 5 }
                    : {
                        marginRight: 10,
                        marginLeft: 5,
                      }
                }
              >
                <Image
                  source={
                    projectProfile
                      ? projectProfile
                      : require("../assets/images/projectImg.png")
                  }
                  style={
                    isMobile
                      ? {
                          height: 20,
                          width: 19,
                          margin: 2,
                        }
                      : {
                          height: 44,
                          width: 43,
                          margin: 5,
                        }
                  }
                />
              </View>
              <View
                style={
                  isMobile
                    ? styles.ProjectName
                    : {
                        // flex: 0.8,
                        borderRightWidth: 2,
                        borderRightColor: "#fff",
                        width: "25%",
                        // height: "85%",
                      }
                }
              >
                <Text
                  // onPress={() => setIsVisible(true)}
                  style={
                    isMobile
                      ? { marginTop: -3, fontSize: 12, color: "#fff" }
                      : { fontSize: 12, color: "#fff" }
                  }
                >
                  {projectTitle}
                  {username == "" ? null : (
                    <TouchableOpacity onPress={() => isAddable()}>
                      <IconEdit
                        name="pencil"
                        size={isMobile ? 10 : 13}
                        color="#fff"
                        style={{
                          padding: 6,
                          // backgroundColor: "#08588E",
                          // borderRadius: 12,
                        }}
                      />
                    </TouchableOpacity>
                  )}
                </Text>
                <Text
                  // onPress={() => setIsVisible(true)}
                  style={[
                    isMobile
                      ? { marginTop: -3, fontSize: 12, color: "#fff" }
                      : { marginRight: 12, fontSize: 10, color: "#fff" },
                    {
                      flexWrap: "wrap",
                      flexShrink: 1,
                      // width: "20%",
                    },
                  ]}
                  numberOfLines={0}
                >
                  {clientName}
                </Text>
              </View>
              <View
                style={
                  isMobile
                    ? {
                        marginLeft: -130,
                        marginTop: 38,
                      }
                    : {
                        // flex: 0.5,
                        // marginTop: 3,
                        borderRightWidth: 2,
                        borderRightColor: "#fff",
                        width: "25%",
                        alignItems: "center",
                        justifyContent: "center",
                      }
                }
              >
                <Text
                  onPress={() => setIsVisible(true)}
                  style={
                    isMobile
                      ? { fontSize: 12, color: "#fff" }
                      : {
                          marginLeft: 5,
                          marginRight: 5,
                          textAlign: "center",
                          fontSize: 12,
                          color: "#fff",
                        }
                  }
                >
                  {projectManager}
                </Text>
              </View>
              <View
                style={
                  isMobile
                    ? {
                        marginLeft: 40,
                        marginRight: -40,
                      }
                    : {
                        marginTop: 3,

                        flexDirection: "column",
                        borderRightWidth: 2,
                        borderRightColor: "#fff",
                      }
                }
              >
                {isLoadingSync ? (
                  <ActivityIndicator
                    //visibility of Overlay Loading Spinner
                    color="#fff"
                    visible={isLoadingSync}
                    //Text with the Spinner
                    textContent={"Loading..."}
                    size={40}
                    //  //Text style of the Spinner Text
                    //  textStyle={{color:'#fff'}}
                  />
                ) : (
                  <IconRefresh
                    style={{ margin: 15 }}
                    color="#fff"
                    name="refresh"
                    size={20}
                    onPress={() => getDashboardRefresh()}
                  />
                )}
              </View>
              <View
                style={{
                  margin: 4,
                  justifyContent: "flex-end",
                  position: "relative",
                  zIndex: 10000,
                }}
              >
                <View style={{ flexDirection: "row", alignItems: "center" }}>
                  <TextInput
                    ref={inputRef}
                    value={searchQuery}
                    style={[
                      styles.dropdown,
                      {
                        width: 200,
                        height: 30,
                        borderWidth: 1,
                        borderColor: "#007bff",
                        borderRadius: 6,
                        paddingHorizontal: 7,
                        fontSize: 14,
                        color: "#000",
                        outline: "none",
                        backgroundColor: "#fff",
                      },
                    ]}
                    placeholder="Search Omega"
                    onChangeText={(text: any) => handleSearch(text)}
                    onBlur={() => {
                      setTimeout(() => {
                        setOmegaDropdownData([]);
                        if (!OmegaValue) {
                          setSearchQuery("");
                        }
                      }, 1000);
                    }}
                  />
                  <OmegaDropdownPortal
                    data={OmegaDropdownData}
                    inputRef={inputRef}
                    renderItem={renderOmegaIdListItems}
                  />
                </View>
                {/* {OmegaDropdownData?.length > 0 && (
                  <FlatList
                    data={OmegaDropdownData}
                    keyExtractor={(item, index) => index.toString()}
                    renderItem={renderOmegaIdListItems}
                    scrollEnabled={true}
                    style={{
                      position: "absolute",
                      top: 45, // just below input
                      width: 200, // same as input
                      maxHeight: 150,
                      backgroundColor: "#fff",
                      borderRadius: 6,
                      borderWidth: 1,
                      borderColor: "#007bff",
                      shadowColor: "#000",
                      shadowOffset: { width: 0, height: 2 },
                      shadowOpacity: 0.3,
                      shadowRadius: 4,
                      elevation: 5,
                      zIndex: 1000,
                    }}
                    contentContainerStyle={{
                      backgroundColor: "#fff",
                      justifyContent: "center",
                      flexGrow: 1,
                    }}
                  />
                )} */}
              </View>
            </View>

            {/* End of project title */}

            {/* Username  */}

            <View
              style={
                isMobile
                  ? {
                      justifyContent: "flex-end",
                      flexDirection: "row",
                      marginTop: 3,
                    }
                  : {
                      justifyContent: "flex-end",
                      flexDirection: "row",
                      marginTop: 3,
                    }
              }
            >
              <View
                style={
                  isMobile
                    ? {
                        // backgroundColor: "black",
                        height: 30,
                        marginLeft: 40,
                      }
                    : {
                        flex: 1,
                        alignItems: "center",
                      }
                }
              >
                {/* <Image
                  source={userIcon}
                  style={{
                    height: 38,
                    width: 28,
                    margin: 5,
                  }}
                  /> */}
                <Image
                  // source={{ uri: profileImage }}

                  source={
                    profileImage
                      ? { uri: profileImage }
                      : require("../assets/images/pricon.png")
                  }
                  style={{ width: 28, height: 38, margin: 6 }}
                />
              </View>
              <View
                style={
                  isMobile
                    ? {
                        marginTop: -10,
                        marginRight: 10,
                        marginLeft: -40,
                      }
                    : {
                        borderRightWidth: 2,
                        borderRightColor: "#fff",
                        // marginTop: 5,
                        // marginBottom: 5,
                      }
                }
              >
                <Text style={{ margin: 15, color: "#fff" }}>{username} </Text>
              </View>
              <View
                style={
                  isMobile
                    ? {
                        marginLeft: -100,
                        marginTop: 30,
                        marginRight: 10,
                      }
                    : {
                        // flex: 1,
                        margin: 15,
                      }
                }
              >
                <Text
                  onPress={() => logout()}
                  // onPress={() => navigation.navigate("Login")}
                  style={{ color: "#fff", marginTop: -3 }}
                >
                  <TouchableOpacity
                    onPress={() => logout()}

                    // onPress={() => navigation.navigate("Login")}
                  >
                    <IconLogout
                      name="poweroff"
                      size={13}
                      color="#fff"
                      style={{
                        padding: 6,
                        // backgroundColor: "#08588E",
                        // borderRadius: 12,
                      }}
                    />
                  </TouchableOpacity>
                  Logout
                </Text>
              </View>
            </View>

            {/* username end */}
          </View>
        )}

        {/* <RootNavigator /> */}
        <ScrollView
          contentContainerStyle={{
            // flex: 1,
            alignItems: "flex-start", // ignore this - we'll come back to it
            justifyContent: "flex-start", // ignore this - we'll come back to it
            flexDirection: "row",
            backgroundColor: "#fff",
            // height:10
            //   padding: 10,
          }}
        >
          {/* {isLoadingSync == true &&
                window.location.reload()
              } */}
          <RootNavigator />
          <ProjectTypeModal />
          {issuccessVisible && (
            <SuccessPopup
              visible={issuccessVisible}
              PopupMessage={PopupMessage}
              Responsestatus={responsestatus}
              onChange={() => setissuccessVisible(false)}
            />
          )}

          {/* <Text>dsfsdf</Text> */}
        </ScrollView>
      </View>
    </View>
  );
}
const Stack = createNativeStackNavigator<RootStackParamList>();

function GridViewStack() {
  return (
    <Stack.Navigator initialRouteName="GridView">
      <Stack.Screen
        name="GridView"
        component={GridView}
        options={{ title: "Monitoring Grid View -Zone", headerShown: false }}
      />
      <Stack.Screen
        name="Zone"
        component={Zone}
        options={{ title: "Monitoring Grid View -Subzone", headerShown: false }}
      />
      <Stack.Screen
        name="Subzone"
        component={Subzone}
        options={{ title: "Monitoring Grid View -Device", headerShown: false }}
      />
      <Stack.Screen
        name="ValveView"
        component={ValveView}
        options={{ title: "Valve View", headerShown: false }}
      />
      {/* Valve details report */}
    </Stack.Navigator>
  );
}
function ZoneViewStack() {
  return (
    <Stack.Navigator initialRouteName="Zone">
      <Stack.Screen
        name="Zone"
        component={Zone}
        options={{ title: "Zone", headerShown: false }}
      />
      <Stack.Screen
        name="Subzone"
        component={Subzone}
        options={{ title: "Subzone", headerShown: false }}
      />
    </Stack.Navigator>
  );
}

function UserMasterStack() {
  return (
    <Stack.Navigator initialRouteName="UserMaster">
      <Stack.Screen
        name="UserMaster"
        component={UserMasters}
        options={{ title: "User Creation", headerShown: false }}
      />
      <Stack.Screen
        name="CreateUserMaster"
        component={CreateUserMaster}
        options={{ title: "Create User Master", headerShown: false }}
      />
      <Stack.Screen
        name="EditUserMaster"
        component={EditUserMaster}
        options={{ title: "Edit User Master", headerShown: false }}
      />
    </Stack.Navigator>
  );
}
function DeviceProfileStack() {
  return (
    <Stack.Navigator initialRouteName="DeviceProfile">
      <Stack.Screen
        name="DeviceProfile"
        component={DeviceProfile}
        options={{ title: "Device Profile", headerShown: false }}
      />
      <Stack.Screen
        name="CreateDeviceProfile"
        component={CreateDeviceProfile}
        options={{ title: "Create Device Profile", headerShown: false }}
      />
      <Stack.Screen
        name="EditDeviceProfile"
        component={EditDeviceProfile}
        options={{ title: "Edit Device Profile", headerShown: false }}
      />
    </Stack.Navigator>
  );
}
function SubzoneProfileStack() {
  return (
    <Stack.Navigator initialRouteName="SubzoneProfile">
      <Stack.Screen
        name="SubzoneProfile"
        component={SubzoneProfile}
        options={{ title: "SubZone Profile", headerShown: false }}
      />
      <Stack.Screen
        name="CreateSubzoneProfile"
        component={CreateSubzoneProfile}
        options={{ title: "Create Subzone Profile", headerShown: false }}
      />
      <Stack.Screen
        name="EditSubzoneProfile"
        component={EditSubzoneProfile}
        options={{ title: "Edit subzone Profile", headerShown: false }}
      />
      <Stack.Screen
        name="ViewSubzoneProfile"
        component={ViewSubzoneProfile}
        options={{ title: "View subzone Profile", headerShown: false }}
      />
    </Stack.Navigator>
  );
}
function ZoneProfileStack() {
  return (
    <Stack.Navigator initialRouteName="ZoneProfile">
      <Stack.Screen
        name="ZoneProfile"
        component={ZoneProfile}
        options={{ title: "Zone Profile", headerShown: false }}
      />
      <Stack.Screen
        name="CreateZoneProfile"
        component={CreateZoneProfile}
        options={{ title: "Create Zone Profile", headerShown: false }}
      />
      <Stack.Screen
        name="EditZoneProfile"
        component={EditZoneProfile}
        options={{ title: "Edit Zone Profile", headerShown: false }}
      />
      <Stack.Screen
        name="ViewZoneProfile"
        component={ViewZoneProfile}
        options={{ title: "View Zone Profile", headerShown: false }}
      />
    </Stack.Navigator>
  );
}
function FarmerProfileStack() {
  return (
    <Stack.Navigator initialRouteName="FarmerProfile">
      <Stack.Screen
        name="FarmerProfile"
        component={FarmerProfile}
        options={{ title: "Farmer Profile", headerShown: false }}
      />
      <Stack.Screen
        name="CreateFarmerProfile"
        component={CreateFarmerProfile}
        options={{ title: "Create Farmer Profile", headerShown: false }}
      />
      <Stack.Screen
        name="EditFarmerProfile"
        component={EditFarmerProfile}
        options={{ title: "Edit Farmer Profile", headerShown: false }}
      />
    </Stack.Navigator>
  );
}
function FarmerDetailsStack() {
  return (
    <Stack.Navigator initialRouteName="EditFarmerDetails">
      <Stack.Screen
        name="EditFarmerDetails"
        component={EditFarmerDetails}
        options={{ title: "Edit Farmer Details", headerShown: false }}
      />
    </Stack.Navigator>
  );
}
function ProjectProfileStack() {
  return (
    <Stack.Navigator initialRouteName="ProjectProfile">
      <Stack.Screen
        name="ProjectProfile"
        component={ProjectProfile}
        options={{ title: "Project Profile", headerShown: false }}
      />
      <Stack.Screen
        name="CreateProjectProfile"
        component={CreateProjectProfile}
        options={{ title: "Create Project Profile", headerShown: false }}
      />
      <Stack.Screen
        name="EditProjectProfile"
        component={EditProjectProfile}
        options={{ title: "Edit Project Profile", headerShown: false }}
      />
      <Stack.Screen
        name="ViewProjectProfile"
        component={ViewProjectProfile}
        options={{ title: "View Project Profile", headerShown: false }}
      />
    </Stack.Navigator>
  );
}
function AccessMasterStack() {
  return (
    <Stack.Navigator initialRouteName="AccessMaster">
      <Stack.Screen
        name="UserAccess"
        component={UserAccess}
        options={{ title: "User Access", headerShown: false }}
      />
      <Stack.Screen
        name="ProjectAccess"
        component={ProjectAccess}
        options={{ title: " Project Access", headerShown: false }}
      />
      <Stack.Screen
        name="DashboardAccess"
        component={DashboardAccess}
        options={{ title: "Dashboard Access", headerShown: false }}
      />
    </Stack.Navigator>
  );
}
function LevelConfiguratorScreen() {
  return (
    <Stack.Navigator initialRouteName="ProjectLevel">
      <Stack.Screen
        name="ProjectLevel"
        component={ProjectLevel}
        options={{ title: "ProjectLevel", headerShown: false }}
      />
      <Stack.Screen
        name="ProjectLevelView"
        component={ProjectLevelView}
        options={{ title: "Level View", headerShown: false }}
      />
    </Stack.Navigator>
  );
}

function RootNavigator() {
  return (
    <Stack.Navigator>
      <Stack.Screen
        name="Dashboard"
        component={HomeScreen}
        options={{
          unmountOnBlur: false,
          title: "Dashboard",
          headerShown: false,
        }}
      />
      <Stack.Screen
        name="DeviceProfile"
        component={DeviceProfileStack}
        options={{ title: "Device Profile", headerShown: false }}
      />
      <Stack.Screen
        name="SubzoneProfile"
        component={SubzoneProfileStack}
        options={{ title: "Sub Zone/Group", headerShown: false }}
      />
      <Stack.Screen
        name="ZoneProfile"
        component={ZoneProfileStack}
        options={{ title: "Zone/Group", headerShown: false }}
      />
      <Stack.Screen
        name="ProjectProfile"
        component={ProjectProfileStack}
        options={{ title: "Project Profile", headerShown: false }}
      />
      <Stack.Screen
        name="FarmerProfile"
        component={FarmerProfileStack}
        options={{ title: "farmer Profile", headerShown: false }}
      />
      {/* <Stack.Screen
        name="EditFarmerDetails"
        component={EditFarmerDetails}
        options={{ title: "farmer Details", headerShown: false }}
      /> */}

      <Stack.Screen
        name="Program"
        component={Program}
        options={{ title: "Program", headerShown: false }}
      />
      <Stack.Screen
        name="ValveAccumulation"
        component={ValveAccumulation}
        options={{ title: "Valve Accumulation", headerShown: false }}
      />
      <Stack.Screen
        name="WaterAccumulation"
        component={WaterAccumulation}
        options={{ title: "Water Accumulation", headerShown: false }}
      />
      <Stack.Screen
        name="Sensor"
        component={Sensor}
        options={{ title: "Sensor", headerShown: false }}
      />
      <Stack.Screen
        name="EnergyLog"
        component={EnergyLog}
        options={{ title: "Energy Log", headerShown: false }}
      />
      <Stack.Screen
        name="ProjectLevel"
        component={LevelConfiguratorScreen}
        options={{ title: "Level Configurator", headerShown: false }}
      />

      <Stack.Screen
        name="UserAccess"
        component={UserAccess}
        options={{ title: "User Access", headerShown: false }}
      />
      <Stack.Screen
        name="ProjectAccess"
        component={ProjectAccess}
        options={{ title: " Project Access", headerShown: false }}
      />
      <Stack.Screen
        name="DashboardAccess"
        component={DashboardAccess}
        options={{ title: " Dashboard Access", headerShown: false }}
      />

      {/* <Stack.Screen
        name="GridView"
        component={GridView}
        options={{ title: "Grid Access", headerShown: false }}
      /> */}
      <Stack.Screen
        name="GridView"
        component={GridViewStack}
        options={{ title: "Grid view", headerShown: false }}
      />
      <Stack.Screen
        name="ValveView"
        component={ValveView}
        options={{ title: "Valve View", headerShown: false }}
      />

      <Stack.Screen
        name="Zone"
        component={ZoneViewStack}
        options={{ title: "zone view", headerShown: false }}
      />
      <Stack.Screen
        name="MapView"
        component={MapView}
        options={{ title: " Map View", headerShown: false }}
      />

      <Stack.Screen
        name="Country"
        component={Country}
        options={{ title: "Country Master", headerShown: false }}
      />
      <Stack.Screen
        name="State"
        component={States}
        options={{ title: "State Master", headerShown: false }}
      />
      <Stack.Screen
        name="City"
        component={City}
        options={{ title: "City Master", headerShown: false }}
      />
      <Stack.Screen
        name="Tahasil"
        component={Tahasil}
        options={{ title: "Tahasil Master", headerShown: false }}
      />
      <Stack.Screen
        name="Village"
        component={Village}
        options={{ title: "Village Master", headerShown: false }}
      />
      <Stack.Screen
        name="DocumentType"
        component={DocumentType}
        options={{ title: "Document Type Master", headerShown: false }}
      />
      <Stack.Screen
        name="UserType"
        component={UserType}
        options={{ title: "User Type", headerShown: false }}
      />
      <Stack.Screen
        name="UserMaster"
        component={UserMasterStack}
        options={{ title: "User Master", headerShown: false }}
      />
      <Stack.Screen
        name="AccessMaster"
        component={AccessMasterStack}
        options={{ title: "AccessMaster", headerShown: false }}
      />
      <Stack.Screen
        name="ProjectType"
        component={ProjectType}
        options={{ title: "Project Master", headerShown: false }}
      />
      <Stack.Screen
        name="OmegaDevice"
        component={OmegaDevice}
        options={{ title: "Omega Device", headerShown: false }}
      />
      <Stack.Screen
        name="Feedback"
        component={Feedback}
        options={{ title: "Feedback", headerShown: false }}
      />

      {/* <Stack.Screen
        name="ProjectLevel"
        component={ProjectLevel}
        options={{ title: "Project Level", headerShown: false }}
      /> */}
      <Stack.Screen
        name="CreateDevice"
        component={CreateDevice}
        options={{ title: "Create Device", headerShown: false }}
      />
      <Stack.Screen
        name="ScheduleProgram"
        component={ScheduleProgram}
        options={{ title: "ScheduleProgram ", headerShown: false }}
      />
      <Stack.Screen
        name="UploadSchedule"
        component={UploadSchedule}
        options={{ title: "UploadSchedule ", headerShown: false }}
      />
      <Stack.Screen
        name="DownloadSchedule"
        component={DownloadSchedule}
        options={{ title: "DownloadSchedule ", headerShown: false }}
      />
      <Stack.Screen
        name="SchedularMapView"
        component={SchedularMapView}
        options={{ title: "SchedularMapView ", headerShown: false }}
      />

      <Stack.Screen
        name="Alerts"
        component={AlertScreen}
        options={{ title: "Alert ", headerShown: false }}
      />
      <Stack.Screen
        name="ValveDetailsReport"
        component={ValveDetailsReport}
        options={{ title: "Valve View", headerShown: false }}
      />

      <Stack.Screen
        name="EnergyStatusDetailReport"
        component={EnergyStatusDetailReport}
        options={{ title: "Sensor View", headerShown: false }}
      />

      <Stack.Screen
        name="SensorDetailsReport"
        component={SensorDetailsReport}
        options={{ title: "Sensor View", headerShown: false }}
      />
      <Stack.Screen
        name="DigitalInputsReport"
        component={DigitalInputsReport}
        options={{ title: "Digital View", headerShown: false }}
      />
      <Stack.Screen
        name="DigitalDetailsReport"
        component={DigitalDetailsReport}
        options={{ title: "Digital Details", headerShown: false }}
      />

      <Stack.Screen
        name="DeviceDetailsReport"
        component={DeviceDetailsReport}
        options={{ title: "device View", headerShown: false }}
      />

      {/* <Stack.Screen
        name="EditFarmerDetails"
        component={EditFarmerDetails}
        options={{ title: "Edit Farmer Details", headerShown: false }}
      /> */}
      <Stack.Group screenOptions={{ presentation: "modal" }}>
        <Stack.Screen name="Modal" component={ModalScreen} />
      </Stack.Group>
    </Stack.Navigator>
  );
}
const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
    padding: 20,
    // marginTop: 200,
  },
  topBarContainer: {
    // flex: 2,
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: "#009DF0",
    justifyContent: "space-between",
    height: "auto",
    // marginBottom: "30%",
  },

  // DropDown CSS
  dropdown: {
    borderColor: "#c3c3c3",
    width: "100%",
    borderWidth: 1,
    borderRadius: 2,
    height: 40,
    padding: 10,
    marginTop: 5,
    marginBottom: 5,
    // borderRadius: 10,
    // padding: 12,
    // shadowColor: "#000",
    // shadowOffset: {
    //   width: 0,
    //   height: 1,
    // },
    // shadowOpacity: 0.2,
    // shadowRadius: 1.41,

    // elevation: 2,
  },
  icon: {
    marginRight: 5,
  },
  item: {
    padding: 9,
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  textItem: {
    flex: 1,
    fontSize: 16,
  },
  placeholderStyle: {
    fontSize: 16,
  },
  selectedTextStyle: {
    fontSize: 16,
  },
  iconStyle: {
    width: 20,
    height: 20,
  },
  inputSearchStyle: {
    height: 40,
    fontSize: 16,
    outlineStyle: "none",
  },
  //Responsive mobile view
  mobileContainer: {
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: "#009DF0",
    justifyContent: "flex-start",
    height: 60,
  },
  ProjectName: {
    marginTop: -5,
    marginBottom: 5,
  },
});
